export const getSellerSummaryByCityUrl =
  "/api/v3/seller/:sellerId/summary/city/:cityId";
export const getSellerSummaryByMediaId =
  "/api/v3/seller/:sellerId/summary/media/:sellerMediaId";
